export const create = {
  createSuccessfully: '社員情報作成は完了しました。',
}
